import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField, { DefaultFormFieldLayout } from 'components/FormField';
import FormStack from 'components/FormStack';
import Icon from 'components/Icon';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import TextInput from 'components/TextInput';
import TextArea from 'components/TextArea';
import { ImageField, TagField, AssetTypeField, LanguageField, CompletionTimeField, formatTags } from 'components/FormFields';
import TitleCard from 'components/TitleCard';
import Box from 'components/Box';
import Hint from 'components/Hint';
import { ContentDetailsInfo } from 'components/ContentInfo';
import { TYPE_ASSET_THUMBNAIL } from 'utils/file';
import config from 'utils/config';
import getContentItemType from 'utils/asset/getContentItemType';
function useDescriptionShortHint(_ref) {
  var description = _ref.description,
    aiSuggestion = _ref.aiSuggestion;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (!aiSuggestion) {
    return null;
  }
  if (aiSuggestion.status === 'pending') {
    return /*#__PURE__*/React.createElement(Text, {
      size: "xs"
    }, /*#__PURE__*/React.createElement(Icon, {
      vAlign: true,
      name: "sparkles",
      mr: "xxs"
    }), t('ai_summary_generating'));
  } else if (aiSuggestion.status === 'error') {
    return /*#__PURE__*/React.createElement(Text, {
      size: "xs"
    }, /*#__PURE__*/React.createElement(Icon, {
      vAlign: true,
      name: "sparkles",
      mr: "xxs"
    }), t('ai_summary_error'));
  } else if (aiSuggestion.status === 'ready') {
    return /*#__PURE__*/React.createElement(Text, {
      size: "xs"
    }, /*#__PURE__*/React.createElement(Icon, {
      vAlign: true,
      name: "sparkles",
      mr: "xxs"
    }), t('ai_summary_available'), ' ', /*#__PURE__*/React.createElement(TextLink, {
      bold: true,
      as: "button",
      onClick: function onClick() {
        return description.set("".concat(description.value, " ").concat(aiSuggestion.value).trim());
      }
    }, t('actions_insert')));
  }
}
function GeneralDetailsCard(_ref2) {
  var isDistributed = _ref2.isDistributed,
    isEditMode = _ref2.isEditMode,
    fields = _ref2.fields,
    content = _ref2.content,
    aiSuggestions = _ref2.aiSuggestions,
    initialAssetDetails = _ref2.initialAssetDetails;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var name = fields.name,
    description = fields.description,
    tags = fields.tags,
    customType = fields.customType,
    locale = fields.locale,
    completionTime = fields.completionTime,
    thumbnailId = fields.thumbnailId;
  var contentId = content === null || content === void 0 ? void 0 : content.id;
  var descriptionHintContent = useDescriptionShortHint({
    description: description,
    aiSuggestion: aiSuggestions === null || aiSuggestions === void 0 ? void 0 : aiSuggestions.description
  });
  return /*#__PURE__*/React.createElement(TitleCard, {
    variant: "raised",
    title: t('menu_general_settings'),
    sideContent: initialAssetDetails && /*#__PURE__*/React.createElement(ContentDetailsInfo, {
      content: initialAssetDetails,
      type: "asset"
    })
  }, /*#__PURE__*/React.createElement(DefaultFormFieldLayout, {
    horizontal: true
  }, /*#__PURE__*/React.createElement(FormStack, {
    spacing: "m"
  }, isEditMode && isDistributed && /*#__PURE__*/React.createElement(Box, null, isDistributed && /*#__PURE__*/React.createElement(Hint, {
    icon: "share"
  }, t('immutability_note_distributed_item_fields'))), /*#__PURE__*/React.createElement(FormField, {
    required: true,
    label: "".concat(t('form_title'), " *"),
    alert: name.wasChanged ? name.error : undefined
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: name.value,
    onChange: function onChange(e) {
      return name.set(e.target.value);
    },
    disabled: isDistributed
  })), /*#__PURE__*/React.createElement(ImageField, {
    id: "assetCoverImage",
    thumbnailId: thumbnailId.value,
    onChange: function onChange(e) {
      return thumbnailId.set(e);
    },
    isDisabled: isDistributed,
    assetType: customType.value,
    contentType: TYPE_ASSET_THUMBNAIL,
    contentId: contentId,
    contentName: name.value,
    contentDescription: description.value
  }), /*#__PURE__*/React.createElement(FormField, {
    label: t('form_description'),
    shortHint: descriptionHintContent
  }, /*#__PURE__*/React.createElement(TextArea, {
    maxRows: 8,
    minRows: 3,
    value: description.value,
    onChange: function onChange(e) {
      return description.set(e.target.value);
    },
    disabled: isDistributed
  })), /*#__PURE__*/React.createElement(TagField
  // Format tags to have all required information for correctly displaying the tag pills
  , {
    selectedTags: formatTags(tags.value),
    onChangeSelectedTags: function onChangeSelectedTags(data) {
      tags.set(data.selectedItems.map(function (tag) {
        return {
          name: tag.name,
          id: tag.id || ''
        };
      }));
    },
    isDisabled: isDistributed
  }), /*#__PURE__*/React.createElement(AssetTypeField, {
    type: customType.value,
    onChange: function onChange(newType) {
      return customType.set(newType);
    },
    originalType: getContentItemType(content || {}, false),
    isDisabled: isDistributed
  }), config.assetLanguageEnabled && /*#__PURE__*/React.createElement(LanguageField, {
    value: locale.value,
    onChange: function onChange(newLocale) {
      return locale.set(newLocale);
    },
    isDisabled: isDistributed
  }), /*#__PURE__*/React.createElement(CompletionTimeField, {
    completionTime: Number(completionTime.value),
    onChange: function onChange(e) {
      return completionTime.set(Number(e.target.value));
    },
    isDisabled: isDistributed
  }))));
}
export default GeneralDetailsCard;